import React from "react";
import { ArrowRight, Star, Check } from "lucide-react";
import { heroImage } from "../mock";
import { LogoMark } from "./Logo";

const Hero = () => {
  return (
    <section className="relative bg-[#0E0E10] text-white pt-32 md:pt-36 pb-20 md:pb-28 px-4 md:px-8 overflow-hidden">
      <div className="max-w-[1300px] mx-auto grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
        {/* Left */}
        <div className="relative z-10">
          <div className="inline-flex items-center gap-2 bg-[#6B7C61] text-white px-4 py-1.5 rounded-full text-sm font-medium mb-7">
            <span className="text-base">🤝</span>
            Compliance Guaranteed
          </div>

          <h1
            className="text-[52px] md:text-[76px] lg:text-[92px] leading-[0.95] font-black tracking-tight uppercase"
            style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
          >
            The bedrock of <br className="hidden md:block" />
            construction payroll.
          </h1>

          <p className="mt-7 text-[17px] md:text-[18px] text-gray-300 leading-relaxed max-w-[560px]">
            At eebssolutions, we keep construction companies like yours doing what you
            do best, while we take care of the rest — payroll, compliance and
            expert advice.{" "}
            <span className="text-white font-semibold">
              With 23+ years of expertise and a flawless HMRC record, we're
              the trusted choice for contractors.
            </span>
          </p>

          <a
            href="#solutions"
            className="mt-9 inline-flex items-center gap-3 bg-[#2D6A4F] hover:bg-[#3D8B6A] text-white font-semibold pl-6 pr-2 py-2 rounded-full transition-all group"
          >
            <span>Find out more</span>
            <span className="bg-white text-[#2D6A4F] w-9 h-9 rounded-full flex items-center justify-center group-hover:translate-x-1 transition-transform">
              <ArrowRight className="w-4 h-4" />
            </span>
          </a>
        </div>

        {/* Right - image + testimonial */}
        <div className="relative">
          <div className="relative rounded-3xl overflow-hidden aspect-[4/3] bg-gray-800">
            <img
              src={heroImage}
              alt="Construction worker"
              className="w-full h-full object-cover"
            />
            <LogoMark
              className="absolute top-5 right-5 w-12 h-12 rotate-12"
              color="#2D6A4F"
            />
          </div>

          {/* Testimonial card */}
          <div className="relative lg:absolute lg:-bottom-10 lg:-left-6 lg:right-8 mt-4 lg:mt-0 bg-white text-[#0E0E10] rounded-2xl p-5 md:p-6 shadow-2xl">
            <div className="flex items-center gap-1 mb-3">
              {[...Array(5)].map((_, i) => (
                <Star
                  key={i}
                  className="w-4 h-4 fill-[#2D6A4F] text-[#2D6A4F]"
                />
              ))}
            </div>
            <p className="text-[15px] leading-relaxed">
              "We have been working with eebssolutions for nearly a year now. We have
              found them to be extremely professional & the service they
              provide exceptional."
            </p>
            <div className="absolute -top-4 -right-3 w-12 h-12 bg-[#6B7C61] rounded-full flex items-center justify-center shadow-lg">
              <Check className="w-6 h-6 text-white" strokeWidth={3} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
